import { createStore } from "vuex";
import { metaStoreModule, type MetaState } from "@/store/meta-store";
import { userStoreModule, type UserState } from "@/store/user-store";
import {
  provisioningStoreModule,
  type ProvisioningState,
} from "@/store/provisioning-store";
import {
  provisioningQosStoreModule,
  type ProvisioningQosState,
} from "@/store/provisioning-qos-store";

// Vuexストアにおけるアプリ全体のルートステート型
export type RootState = {
  meta: MetaState;
  user: UserState;
  provisioning: ProvisioningState;
  provisioningQos: ProvisioningQosState;
};
// 新しいストアインスタンスを作成します
export const store = createStore<RootState>({
  strict: process.env.NODE_ENV === "development",
  modules: {
    meta: metaStoreModule,
    user: userStoreModule,
    provisioning: provisioningStoreModule,
    provisioningQos: provisioningQosStoreModule,
  },
});
